import './TitleBlock.scss';

export default function TitleBlock({ title, id }) {
  return (
    <h2 className='title-block' id={id}>
      {title}
    </h2>
  );
}